export default __webpack_public_path__ + "static/media/group789.2002c626.svg";